
$(".btn-lo-quiero").click(function(){
	console.log($(this).attr("data-id-product-variant"))
    event.stopPropagation();
    let formData = {
      'items': [{
      	'id': parseInt($(this).attr("data-id-product-variant")),
      	'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
      })
      .then(response => {
        if(response.status == 200){
          let total = 0;
          let cantItemsCart = 0;
          $.ajax({
            type: "GET",
            url: "/cart.json",
            async: !1,
            success: function (data) {
              total = data.total_price;
              cantItemsCart = data.item_count;
           },
           error: function (e) {
                console.log(e)
           }
          });
          $("#popUpAddCartColecciones").attr("style", "display: block; animation: zoomAnimation 2s;")
          $("#container-info-product").empty();
          if($(this).attr("data-compare-price") != ""){
            $("#container-info-product").append("<img src='"+$(this).attr("data-url-image")+"' alt='"+$(this).attr("data-title")+"'/><div class='info-product-pop-add-cart' data-url-product='"+$(this).attr("data-url-product")+"'><span>"+$(this).attr("data-title")+"</span><span>"+$(this).attr("data-price")+"</span><span>"+$(this).attr("data-compare-price")+"</span></div>");
          }else{
            $("#container-info-product").append("<img src='"+$(this).attr("data-url-image")+"' alt='"+$(this).attr("data-title")+"'/><div class='info-product-pop-add-cart' data-url-product='"+$(this).attr("data-url-product")+"'><span>"+$(this).attr("data-title")+"</span><span>"+$(this).attr("data-price")+"</span></div>")
          }
          
          $("#totalAddCartColecciones").text(theme.Currency.formatMoney(total, theme.moneyFormat))
          $("#countCartTotal").text(cantItemsCart)

          $(this).text("Producto agregado al carrito!").css("background","#00A4A1").css({
          "border": "1px solid #00A4A1",
          "color": "#FFFFFF"
          });
           if($("#CartCount").is(":visible")){
             let cantCountCart = parseInt($("#CartCount").find("#cart-count-header").text());
             $("#CartCount").find("#cart-count-header").text(cantCountCart+1);
           }else{
             $("#CartCount").attr("style", "display: flex !important;").find("#cart-count-header").text("1"); 
           }
      }
      
       
	})
    .catch((error) => {
       console.error('Error:', error);
    });
})

